import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Sidebar from "./Sidebar";

import styles from './css/Header.module.css';
import axios from "axios";

export default function Header() {
    const location = useLocation();
    // 사이드바 가시 여부
    const [ isMenu, setIsMenu ] = useState(false);
    // 푸시 알람 개수
    const [ pushCount, setPushCount ] = useState(0);

    const [ userType, setUserType ] = useState('guest');
    // Set UserType
    useEffect(() => {
        const user = localStorage.getItem('user');
        if(user) setUserType(user);
    }, []);

    function debounce(func, delay) {
        let timeoutId = null; // 타이머 ID를 저장할 변수

        // 클로저를 활용하여 외부 함수의 변수에 접근
        return function(...args) {
            // 새로운 호출이 발생하면 이전 타이머를 취소
            clearTimeout(timeoutId);

            // 새로운 타이머를 설정
            timeoutId = setTimeout(() => {
            // 지정된 시간이 경과한 후 원래 함수를 실행
            func.apply(this, args);
            }, delay);
        };
    }

    const pushadd = () => {
        setPushCount((prev) => prev+1);
    };
    const addPush = debounce(pushadd, 1000);

    const setPush = (count) => {
        setPushCount(Number(count));
    };

    const sendToken = (token) => {
        axios.post('/api/users/fcm', {fcmToken: token}, {timeout: process.env.REACT_APP_API_TIMEOUT})
            .then(()=>{})    
            .catch(() => {});
    }

    useEffect(() => {
        window.addPush = addPush;
        window.setPush = setPush;
        window.sendToken = sendToken;
    // eslint-disable-next-line
    }, []);

    return (
        <div style={{display: (location.pathname.includes('download')) ? 'none' : 'block'}}>
            {/* Sidebar */}
            <Sidebar isMenu={isMenu} setIsMenu={setIsMenu} />

            {/* Header */}
            <div className={styles.header}>
                {/* Menu Icon = Sidebar Trigger */}
                <div className={styles.header_menu_area}>
                    <button className={styles.header_menu_button} onClick={() => setIsMenu(true)} style={{ background: "none", border: "none" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 -960 960 960" fill="#FFFFFF">
                            <path d="M144-264v-72h672v72H144Zm0-180v-72h672v72H144Zm0-180v-72h672v72H144Z"/>
                        </svg>
                    </button>
                </div>
                {/* Title Logo */}
                <Link to="/">
                    <div className={styles.header_title_area}>
                        <img src="/imgs/logo.png" alt="logo" />
                        <span>행정마당</span>
                    </div>
                </Link>
                {/* Alert Icon */}
                <div className={styles.header_icons_area}>
                    {(userType !== 'guest') ?
                    <button onClick={() => {
                        // eslint-disable-next-line
                        window.Push.postMessage('clear');
                        setPushCount(0);
                        window.location.href = '/quote_list';
                    }} style={{ background: "none", border: "none", marginRight: 10, position: 'relative' }}>
                        <div style={{display: (pushCount === 0) ? 'none' : null}} className={styles.bell_count}>
                            {(pushCount > 9) ? '9+' : pushCount}
                        </div>
                        <img className={styles.alertImg} src="/imgs/bell.png" alt="push" />
                    </button> : null
                    }
                    {
                    (userType === 'member') ?
                    <Link to='/profile/member'>
                        <button className={styles.homeButton}>
                            <img src="/imgs/house.png" alt="home" />
                        </button>
                    </Link> : null
                    }
                </div>
            </div>
        </div>
    );
}